type ReportClientErrorInput = {
  kind:
    | 'window_error'
    | 'window_error_opaque'
    | 'resource_error'
    | 'unhandled_rejection'
    | 'vue_error'
    | 'api_error'
    | 'lifecycle_trace'
    | 'heartbeat_trace'
    | 'unknown'
  message: string
  stack?: string | null
  requestId?: string | null
  meta?: Record<string, unknown>
}

function makeId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `bb_${Date.now()}_${Math.random().toString(16).slice(2)}`
}

export async function reportClientError(input: ReportClientErrorInput): Promise<string> {
  const config = useRuntimeConfig()
  const route = useRoute()
  const eventId = makeId()
  const requestId = input.requestId ?? makeId()

  const payload = {
    eventId,
    requestId,
    kind: input.kind,
    message: input.message.slice(0, 4000),
    stack: input.stack?.slice(0, 12000) ?? null,
    route: route.fullPath,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    occurredAt: new Date().toISOString(),
    meta: input.meta ?? null,
  }

  try {
    await fetch(`${config.public.apiBase}/api/telemetry/client-error`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Request-Id': requestId,
      },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify(payload),
    })
  } catch {
    // Best effort only: telemetry must never break gameplay.
  }

  return eventId
}
